<template>
    <div class="tool-container widget">
        <div class="tool-list">
            <div class="tool-button" @click="changeModel(0)" :style="plotModel == 0 ? { background: '#00000040' } : ''">
                <div class="icon"><i class="iconfont button-icon">&#xe611;</i></div>
                <div class="text">拼接</div>
            </div>
            <div class="more" v-show="showMore">
                <div class="tool-button" @click="changeModel(1)"
                    :style="plotModel == 1 ? { background: '#00000040' } : ''">
                    <div class="icon"><i class="iconfont button-icon">&#xe60f;</i></div>
                    <div class="text">标线</div>
                </div>

                <el-popconfirm title="确定删除当前所有标绘么？" @confirm='clearAll()'>
                    <div class="tool-button" ref="clearAll" slot='reference'>
                        <div class="icon"><i class="iconfont button-icon">&#xe6c7;</i></div>
                        <div class="text">清除</div>
                    </div>
                </el-popconfirm>

                <div class="tool-button" @click="searchDialog.show = !searchDialog.show">
                    <div class="icon"><i class="iconfont button-icon">&#xe68b;</i></div>
                    <div class="text">找点</div>
                </div>

            </div>


            <div class="tool-button" @click="showMore = !showMore">
                <div class="icon"><i class="iconfont button-icon" v-html="showMore ? upIcon : downIcon"></i></div>
                <div class="text">工具</div>
            </div>
        </div>

        <SearchDialog :show.sync="searchDialog.show" />
        <SpliceDialog :show.sync="showSpliceDialog" :info="spliceInfo"></SpliceDialog>
    </div>

</template>

<script>
import { removeAllPlot, baseLayerConfig } from '@/util/mapManager.js'

import plotRectangle from '../../util/plotRectangle'

import plotPolyline from '../../util/plotPolyline'

import formatter from '@/util/geoUtil.js'
import SearchDialog from './SearchDialog.vue'
import SpliceDialog from './SpliceDialog.vue'


export default {
    name: 'ToolBar',
    components: {
        SearchDialog,
        SpliceDialog
    },
    data() {
        return {
            showMore: false,
            upIcon: '&#xe666;',
            downIcon: '&#xe665;',
            isDrawingRectangle: false,
            plotModel: -1,
            searchDialog: {
                show: false
            },
            showSpliceDialog: false,
            spliceInfo: {
                name: '',
                leftTop: null,
                rightBottom: null,
                grid: 0,
                gridColor: '#000000',
                gridWidth:2,
                level: 15,
                info: ''
            }
        }
    },
    methods: {
        //确认下载
        confirmSplice(data) {
            if (baseLayerConfig.getBaseLayerSource() == null) {
                this.$message.error('当前无地图')
                return
            }
            this.showSpliceDialog = true
            this.isDrawingRectangle = false
            this.spliceInfo = {
                name: '任务' + new Date().getTime(),
                leftTop: data.leftTop,
                rightBottom: data.rightBottom,
                info: data.info,
                grid: 0,
                gridColor: '#000000',
                gridWidth:2,
                zoom: 15,
                mapSourceName: baseLayerConfig.getBaseLayerSource().name,
                mapSourceId:baseLayerConfig.getBaseLayerSource().id
            }
        },
        clearAll() {
            if (this.plotModel != -1) {
                this.$message.error('请先结束绘制')
                return
            }
            removeAllPlot()
        },
        splice() {
            console.log('start')
        },
        changeModel(model) {
            plotPolyline.end()
            plotRectangle.end()
            if (this.plotModel == model) {
                this.plotModel = -1
                return
            }
            this.plotModel = model
            switch (this.plotModel) {
                case 0:
                    plotRectangle.start(this.confirmSplice)
                    break;
                case 1:
                    plotPolyline.start()
                    break;
            }
        }
    }
}
</script>
<style scoped>
.tool-container {
    background-color: white;
    position: absolute;
    top: 160px;
    border-radius: 4px;
    right: 16px;
}

.tool-list {

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
}

.tool-button {
    width: 48px;
    padding: 4px 0;
}

.tool-button {
    width: 48px;
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    padding-top: 4px;
    cursor: pointer;
}

.button-icon {
    font-size: 1.5em;
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/main/ToolBar.vue